import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

export const GetAllState = createAsyncThunk(
  "masters/state/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Masters.State}?term=${filter?.name || ""}&searchCountry=${filter?.country_id || ""
        }&page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page || IDS.PERPAGE
        }`
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Get a specific state
export const GetState = createAsyncThunk(
  "masters/state/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Masters.State}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Create a new state
export const AddState = createAsyncThunk(
  "masters/state/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Masters.State, data);
      if (res?.success) {
        return res;
      }
      return rejectWithValue(res); // The new state object
    } catch (error) {
      console.log(error, "error state");
      return rejectWithValue(error);
    }
  }
);
// Update a state
export const UpdateState = createAsyncThunk(
  "masters/state/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(`${APIS.Masters.State}/${id}`, data);
      if (res?.success) {
        return res;
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
// Delete a state
export const DeleteState = createAsyncThunk(
  "masters/state/delete",
  async (id, { rejectWithValue }) => {
    try {
      await DELETE(`${APIS.Masters.State}/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Change the status of a state
export const StatusState = createAsyncThunk(
  "masters/state/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Masters.State}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "state",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllState.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllState.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllState.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(GetState.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetState.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetState.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AddState.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AddState.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data.unshift(action.payload.data);
      })
      .addCase(AddState.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(UpdateState.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(UpdateState.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        const index = state.data.findIndex(
          (stateItem) => stateItem.id === action.payload?.data?.id
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(UpdateState.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(DeleteState.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(DeleteState.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = state.data.filter(
        //   (stateItem) => stateItem.id !== action.payload
        // );
        state.data = state.data.filter(
          (stateItem) => stateItem.id !== action.payload
        );
      })
      .addCase(DeleteState.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(StatusState.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusState.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        const index = state.data.findIndex(
          (stateItem) => stateItem.id === action.payload?.id
        );
        if (index !== -1) {
          state.data[index].status = !state.data[index].status;
        }
      })
      .addCase(StatusState.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export default Slice.reducer;
